import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { Utils } from '@/utils/utils';

@Component({
    selector: 'send-to-tablet-modal',
    imports: [CustomModalComponent],
    templateUrl: './send-to-tablet-modal.component.html',
})
export class SendToTabletModalComponent implements OnInit {
    @Input() documentId!: number;
    @Output() closeFunction = new EventEmitter<any>();
    @Output() acceptFunction = new EventEmitter<any>();

    loading = true;
    sendingId: number | null = null;
    tablets: any[] = [];

    constructor(private apiService: ApiService, private cdr: ChangeDetectorRef) { }

    ngOnInit(): void {
        this.loadTablets();
    }

    loadTablets(): void {
        this.loading = true;
        this.apiService.getPetition(`${Urls.urls.documents}/${this.documentId}/tablets`).subscribe({
            next: (result: any) => {
                this.tablets = result.list || [];
                this.loading = false;
                this.cdr.detectChanges();
            },
            error: (error: any) => {
                Utils.notification.alert(Utils.extractErrorMessage(error) || 'No se pudieron cargar las tablets');
                this.loading = false;
                this.cdr.detectChanges();
            },
        });
    }

    sendTo(tablet: any): void {
        if (this.sendingId) return;
        this.sendingId = tablet.id;

        this.apiService.post(`${Urls.urls.documents}/${this.documentId}/send-to-tablet`, { tablet_id: tablet.id }).subscribe({
            next: () => {
                Utils.notification.success('Petición de firma enviada a ' + tablet.name);
                this.sendingId = null;
                this.acceptFunction.emit();
            },
            error: (error: any) => {
                Utils.notification.alert(Utils.extractErrorMessage(error) || 'No se pudo enviar la petición de firma');
                this.sendingId = null;
                this.cdr.detectChanges();
            },
        });
    }

    closeFormFunction(): void {
        this.closeFunction.emit();
    }
}
